export default "__VITE_ASSET__CkvttYnr__"